import { DataGrid } from "devextreme-react";
import { Column, ColumnChooser, Grouping, GroupPanel, Pager, Paging, SearchPanel } from "devextreme-react/data-grid";
import { MovementTypeColumn } from "./MovementTypeColumn";
import React from "react";
import { IDismissalEmployeeTransactionRecordDto } from "../../../dtos/transactions/IDismissalEmployeeTransactionRecordDto";

interface IProps {
  items: IDismissalEmployeeTransactionRecordDto[];
}

export const DismissalEmployeeTransactionRecordTable = ({ items }: IProps) => {
  const pageSizes = [10, 25, 50, 100];

  return (
    <>
      <div className={"overflow-auto"}>
        <DataGrid
          dataSource={items}
          sorting={{ mode: "multiple" }}
          allowColumnReordering={true}
          rowAlternationEnabled={false}
          showBorders={false}
          showRowLines={true}
          allowColumnResizing={true}
          selection={{ mode: "single" }}
          loadPanel={{ enabled: true, showIndicator: true, showPane: false }}
        >
          <ColumnChooser enabled={true} />
          <GroupPanel visible={true} />
          <SearchPanel visible={true} highlightCaseSensitive={true} />
          <Grouping autoExpandAll={false} />

          <Column
            dataField="tableMovementType"
            dataType="string"
            caption={"Movement Type"}
            width={100}
            cellRender={(column: any) => {
              return <MovementTypeColumn column={column} />;
            }}
          />

          <Column width={150} dataField={"period"} dataType={"datetime"} caption={"Period"} sortOrder={"asc"} sortIndex={1} />

          <Column width={75} dataField={"personId"} dataType="string" />
          <Column width={75} dataField={"employeeId"} dataType="string" />
          <Column width={75} dataField={"companyId"} dataType="string" />
          <Column width={75} dataField={"dismissalDate"} dataType="datetime" />
          <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
          <Paging defaultPageSize={10} />
        </DataGrid>
      </div>
    </>
  );
};
